export const T = {
  en_GB: { noContent: "No embed content configured" },
  nb_NO: { noContent: "Ikke noe innebygd innhold er konfigurert" },
} as const;
